import { addSideEffects, initAction } from '@poa/state';
import moment from 'moment';
import { clone } from '../shared/clone';
import {
  changeColumnPreset,
  deletePreset,
  fetchReports,
  fetchEmptyReports,
  saveColumnPreset,
  setDates
} from './reports.actions';

export const reportsAvailablePresets = 'reportsAvailablePresets-v2';
export const reportsLastSelectedPreset = 'reportsLastSelectedPreset-v2';

addSideEffects(fetchReports, async (_, { actions, store, env }) => {
  try {
    // fetch statuses
    const reportsStatuses = await env.api.reports.fetchReportsStatuses();
    actions.reportsActions.resetStatuses(reportsStatuses);

    // fetch sorting
    const reportsGrouping = await env.api.reports.fetchReportsGrouping();
    actions.reportsActions.resetGrouping(reportsGrouping);

    // fetch reports
    const reports = await env.api.reports.fetchReports(
      store.reports.filters.startDate,
      store.reports.filters.endDate
    );

    reports.loaded ? actions.reportsActions.fetchReportsWaiting(reports.loaded) : actions.reportsActions.fetchReportsSuccess(reports.data);
  } catch (e) {
    console.error(e);
    actions.reportsActions.fetchReportsFailed();
    throw e;
  }
});

addSideEffects(fetchEmptyReports, async (_, { actions, store, env }) => {
  try {

    if (store.reports.meta.loaded) {
      return;
    }

    // fetch statuses
    const reportsStatuses = await env.api.reports.fetchReportsStatuses();
    actions.reportsActions.resetStatuses(reportsStatuses);

    // fetch sorting
    const reportsGrouping = await env.api.reports.fetchReportsGrouping();
    actions.reportsActions.resetGrouping(reportsGrouping);

    const filteredData = JSON.parse((localStorage.getItem(`reportDataState_${store.auth.currentHost}`))) || [];

    if (filteredData.length > 0) {
      actions.reportsActions.fetchReportsSuccess(filteredData);
    } else {
      // fetch empty reports
      let reports = await env.api.reports.fetchEmptyReports();
      actions.reportsActions.fetchReportsSuccess(reports);
    }

  } catch (e) {
    console.error(e);
    actions.reportsActions.fetchReportsFailed();
    throw e;
  }
});

addSideEffects(setDates, async ({ startDate, endDate, shouldFetch = false }, { actions, env }) => {
  if (!shouldFetch) {
    return;
  }

  await env.storage.setItem('reports-dates', clone({ startDate, endDate }));
});

// persist settings
addSideEffects(saveColumnPreset, async (_, { env, store }) => {
  const { availablePresets, currentPresetId } = store.reports.filters.columnSettings;

  await env.storage.setItem(reportsAvailablePresets, clone(availablePresets));
  await env.storage.setItem(reportsLastSelectedPreset, currentPresetId);
});

addSideEffects(deletePreset, async (_, { env, store }) => {
  const { availablePresets, currentPresetId } = store.reports.filters.columnSettings;

  await env.storage.setItem(reportsAvailablePresets, clone(availablePresets));
  await env.storage.setItem(reportsLastSelectedPreset, currentPresetId);
});

addSideEffects(changeColumnPreset, async (_, { env, store }) => {
  const { currentPresetId } = store.reports.filters.columnSettings;

  await env.storage.setItem(reportsLastSelectedPreset, currentPresetId);
});

// Restore presets on load
addSideEffects(initAction, async (_, { actions, env, store }) => {
  const availablePresets = await env.storage.getItem(reportsAvailablePresets);
  const presetId = await env.storage.getItem(reportsLastSelectedPreset);
  const dates = await env.storage.getItem('reports-dates');


  if (dates) {
    await env.storage.setItem('reports-dates', clone({
      startDate: dates.startDate ? moment(dates.startDate) : null,
      endDate: dates.endDate ? moment(dates.endDate) : null
    }));
    return;
  }

  if (availablePresets && presetId) {
    actions.reportsActions.resetColumnSettings({ presetId, availablePresets });
    return;
  }

  if (availablePresets) {
    actions.reportsActions.resetColumnSettings({
      presetId: availablePresets[0].id, // default one
      availablePresets
    });
    return;
  }

  actions.reportsActions.resetColumnSettings({
    presetId: store.reports.filters.columnSettings.availablePresets[0].id, // default one
    availablePresets: store.reports.filters.columnSettings.availablePresets
  });
});
